var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"grid gap-5 grid-cols-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3"},[_c('div',[_c('line-chart')],1),_c('div',[_c('bar-chart')],1),_c('div',[_c('doughnut-chart')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }